import React from 'react';
import { Mail, MessageCircle, Instagram, Youtube, Twitter } from 'lucide-react';
import KangoLogo from './KangoLogo';

const Footer = () => {
  return (
    <footer className="relative bg-[#070707] border-t border-white/5 pt-20 pb-10">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <KangoLogo className="w-11 h-11 text-amber-400 transition-transform duration-300 group-hover:scale-105" />
              <div className="flex items-center">
                <div className="flex flex-col leading-tight">
                  <span className="text-white font-serif text-[18px] tracking-[0.18em]">KANGO</span>
                  <span className="text-white/70 font-serif text-[11px] tracking-[0.42em]">SCHOOL</span>
                </div>
                <span className="text-amber-400 text-[35px]">9</span>
              </div>
            </div>
            <p className="mt-6 text-white/55 max-w-md leading-relaxed text-[15px]">
              Online Go lessons from an 8 Dan WBaduk player. Personalized, friendly, and built
              to help you actually improve.
            </p>
          </div>

          <div className="lg:col-span-2">
            <div className="text-white/40 text-xs uppercase tracking-wider mb-4">Site</div>
            <ul className="space-y-3 text-white/70 text-[15px]">
              <li><a href="#home" className="hover:text-amber-400">Home</a></li>
              <li><a href="#lessons" className="hover:text-amber-400">Lessons</a></li>
              <li><a href="#teacher" className="hover:text-amber-400">Teacher</a></li>
              <li><a href="#reviews" className="hover:text-amber-400">Reviews</a></li>
            </ul>
          </div>
          <div className="lg:col-span-2">
            <div className="text-white/40 text-xs uppercase tracking-wider mb-4">Learn</div>
            <ul className="space-y-3 text-white/70 text-[15px]">
              <li><a href="#blog" className="hover:text-amber-400">Blog</a></li>
              <li><a href="#book" className="hover:text-amber-400">Book on Amazon</a></li>
              <li><a href="#about" className="hover:text-amber-400">About</a></li>
            </ul>
          </div>
          <div className="lg:col-span-3">
            <div className="text-white/40 text-xs uppercase tracking-wider mb-4">Contact</div>
            <ul className="space-y-3 text-white/70 text-[15px]">
              <li className="flex items-center gap-2"><Mail size={14} className="text-amber-400" /> baduk@kango9school.com</li>
              <li className="flex items-center gap-2"><MessageCircle size={14} className="text-amber-400" /> +40 727 949 772</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-3 text-white/40 text-sm">
          <div>© {new Date().getFullYear()} Kango9 School. All rights reserved.</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
